import styles from './TableBlock.module.scss';

export interface ITableBlockProps {
  id: number;
  table_row: ITableRowProps[];
  title: string;
}

interface ITableRowProps {
  id: number;
  title: string;
  description: string;
}

function TableBlock(props: ITableBlockProps) {
  return (
    <div className={`d-fl jc-c ai-c fd-c ${styles.block}`}>
      {props.title && <h1>{props.title}</h1>}
      <div className={styles.table}>
        {props.table_row?.map(row => (
          <div key={row.id} className={`d-fl ai-c ${styles.table_row}`}>
            <span className={styles.title_text}>{row.title}</span>
            <span className={styles.description_text}>{row.description}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TableBlock;
